import React, { ReactElement } from 'react';
import './WalletTabs.scss';

export interface TabsProps {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}

export const WalletTabs = ({
  activeTab,
  setActiveTab,
}: TabsProps): ReactElement => {
  const tabItems = ['獲得履歴', '使用履歴'];

  return (
    <ul className="wallet-tabs">
      {tabItems.map((item, idx) => (
        <li key={idx}>
          <button
            type="button"
            onClick={() => setActiveTab(idx)}
            className="wallet-tabs__button"
          >
            {item}
            <span
              className="wallet-tabs__underline"
              hidden={activeTab !== idx}
            ></span>
          </button>
        </li>
      ))}
    </ul>
  );
};
